

if ($(window).width() < 990 && $("body").hasClass("template-collection-brand-blocks-main")) {
    $(".card-brand-block").each(function (i) {
      $(this).addClass("editorial--block-" + (i + 1));
    });

    $(".plp-product-standard").each(function (i) {
      $(this).addClass("product--block-" + (i + 1));
    });

    $(".editorial--block-1").insertAfter(".product--block-2");

    $(".editorial--block-2").insertAfter(".product--block-4");

    $(".editorial--block-3").insertAfter(".product--block-6");

    $(".editorial--block-4").insertAfter(".product--block-8");

    $(".editorial--block-5").insertAfter(".product--block-10");

    $(".editorial--block-6").insertAfter(".product--block-12");

    $(".editorial--block-7").insertAfter(".product--block-14");

    $(".editorial--block-8").insertAfter(".product--block-16");
  } else if ($(window).width() < 990 && $("body").hasClass("template-collection-brand-blocks") && !$("body").hasClass("gifts-collection")) {
    $("#product-grid .card-brand-block").each(function (i) {
      $(this).addClass("editorial--block-" + (i + 1));
    });

    $(".plp-product-standard").each(function (i) {
      $(this).addClass("product--block-" + (i + 1));
    });

    setTimeout(function () {
      if ($("main .plp-product-standard").length == 5 && $(window).width() < 991 && $('body').hasClass('template-gift-finder')) {
        $(".card-brand-block").insertAfter("main .product--block-5");
      }
    },100);
    

    $(".editorial--block-1").insertAfter(".product--block-4");

    if (!$('body').hasClass('gift-collection') && !$("body").hasClass("sale-area") && !$('body').hasClass('brand-blocks-new')) {
      $(".editorial--block-2").insertAfter(".product--block-8");

      $(".editorial--block-3").insertAfter(".product--block-12");

      $(".editorial--block-4").insertAfter(".product--block-16");

      $(".editorial--block-5").insertAfter(".product--block-20");

      $(".editorial--block-6").insertAfter(".product--block-24");

      $(".editorial--block-7").insertAfter(".product--block-28");

      $(".editorial--block-8").insertAfter(".product--block-32");
    }

    if ($("body").hasClass("sale-area") || $('body').hasClass('brand-blocks-new')) {
      $(".editorial--block-2").insertAfter(".product--block-12");

      $(".editorial--block-3").insertAfter(".product--block-20");

      $(".editorial--block-4").insertAfter(".product--block-28");

      $(".editorial--block-5").insertAfter(".product--block-36");

      $(".editorial--block-6").insertAfter(".product--block-44");

      $(".editorial--block-7").insertAfter(".product--block-50");

  
    }
  }
  if ($("body").hasClass("sale-area")) {
  $(".plp-product-standard").each(function (i) {
    $(this).addClass("product--block-" + (i + 1));
  });
}

  setTimeout(function() {
    $('body').removeClass('body-hidden');
  },0300);
